import request from "./request";

export default {
    getCourses({ commit, state }) {
        return new Promise((resolve, reject) => {
            commit("SET_KEY", '');
            commit("SET_LOADER", true);
            request
                .getCourses()
                .then((data) => {
                    commit("SET_COURSES", data);
                    commit("SET_LOADER", false);
                    resolve(data);
                })
                .catch((err) => {
                    commit("SET_LOADER", false);
                    reject(err);
                });
        });
    },

    getAllCourses({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit("SET_KEY", '');
            commit("SET_LOADER", true);
            request
                .getAllCourses(params.category_id, params.proyect_id)
                .then((data) => {
                    commit("SET_ALL_COURSES", data);
                    commit("SET_LOADER", false);
                    resolve(data);
                })
                .catch((err) => {
                    commit("SET_LOADER", false);
                    reject(err);
                });
        });
    },

    getCoursesByKey({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADER", true);
            commit("SET_KEY", params.key_code);
            request
                .getCoursesByKey(params.key_code)
                .then((data) => {
                    commit("SET_ALL_COURSES", data);
                    commit("SET_LOADER", false);
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                    commit("SET_LOADER", false);
                });
        });
    },

    getCoursesDetail({ commit }, params) {
        return new Promise((resolve, reject) => {
            request
                .getCoursesDetail(params.course_id, process.env.VUE_APP_PROYECT_ID)
                .then((data) => {
                    commit('SET_SELECTED_COURSE', data)
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    },

    getExternalAllCourses({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_KEY", '');
            commit("SET_LOADER", true);
            request
                .getExternalAllCourses(data)
                .then((data) => {
                    commit("SET_ALL_COURSES", data);
                    commit("SET_LOADER", false);
                    resolve(data);
                })
                .catch((err) => {
                    commit("SET_LOADER", false);
                    reject(err);
                });
        });
    },
};